'use client';

import React from 'react';
import Link from 'next/link';
import SEO from '../components/common/SEO';
import { ArrowLeft, Heart } from 'lucide-react';

const NotFoundPage: React.FC = () => {
  return (
    <>
      <SEO 
        title="Page Not Found - HeavenGirlfriend"
        description="The page you're looking for doesn't exist."
        canonicalUrl=""
      />
      
      {/* Prevent indexing of 404 page */}
      <meta name="robots" content="noindex, nofollow" />
      <meta name="googlebot" content="noindex, nofollow" />
      
      <div className="min-h-screen bg-charcoal-950 flex items-center justify-center px-4">
        <div className="text-center max-w-lg">
          <Heart className="h-20 w-20 mx-auto mb-6 text-primary-400 opacity-40" />
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-offwhite mb-6">
            Playful, but not found
          </h1>
          
          <p className="text-xl text-charcoal-300 mb-10">
            The digital connection you're looking for seems to have wandered off. Let's get you back on track.
          </p>
          
          <Link
            href="/"
            className="btn-primary inline-flex items-center gap-2"
          >
            <ArrowLeft className="h-5 w-5" />
            <span>Back to Home</span>
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFoundPage;
